import { combineReducers } from 'redux';

import { authentication } from './authentication';
import { registration } from './registration';
import { users } from './user';
import { alert } from './alert';
import { modal } from './modal';
import { game } from './game';
import { games } from './games';
import { player } from './player';

const rootReducer = combineReducers({
  authentication,
  registration,
  users,
  alert,
  modal,
  game,
  games,
  player
});

export default rootReducer;